const documents = {
    cells: {
      "title": "Excel cell reference",
      "notice": "Read-only cell values; original formatting and drawings are not reproduced. Click then Shift-click to select up to 400 cells. Questions use only the selected range. Include the entire merged range.",
      "sheet": "Sheet",
      "ask": "Ask about this range",
      "loading": "Loading cells…",
      "stale": "This document has changed. Display stopped because it no longer matches this citation.",
      "failed": "Could not load cell reference.",
      "grid": "Excel cells",
      "hidden": "Hidden",
      "noCache": "Formula cache unavailable",
      "merges": "Merged ranges (value in top-left cell)",
      "previousRows": "Previous 100 rows",
      "nextRows": "Next 100 rows",
      "previousColumns": "Previous 20 columns",
      "nextColumns": "Next 20 columns",
      "toggle": "Toggle cells / simple preview",
      "scope": "Selected range only",
      "selectionFailed": "Unable to verify the Excel reference. Check the document version, permissions and selection, then select again."
},
    columns: {
      title: 'Document',
      category: 'Category',
      size: 'Size',
      updatedAt: 'Updated',
    },
    countLabel: '{{count}} documents',
    title: 'Documents',
    uploadDocument: 'Upload Document',
    documentList: 'Document List',
    gridView: 'Grid View',
    listView: 'List View',
    searchPlaceholder: 'Search documents...',
    filters: 'Filters',
    applyFilters: 'Apply Filters',
    sortBy: 'Sort',
    sortOptions: {
      date: 'Date',
      name: 'Name',
      size: 'Size',
      category: 'Category',
    },
    dateInput: {
      startLabel: 'Start date',
      endLabel: 'End date',
      format: 'YYYY-MM-DD',
      invalid: 'Enter the date as YYYY-MM-DD',
      reversed: 'The start date must be on or before the end date',
    },
    sortOrder: {
      asc: 'ascending',
      desc: 'descending',
    },
    noDocumentsFound: 'No documents found',
    tryAdjustingFilters: 'Try adjusting your filters or search query',
    duplicateUpload: 'A file with the same content has already been uploaded',
    generalCategory: 'General',
    deepAnalyzed: 'Deep analyzed',
    loadMore: 'Load more',
    resultsCount: '{{shown}} / {{total}} documents',
    shareDocument: 'Share Document',
    shareComingSoon: 'Sharing is currently under development.',
    deleteTitle: 'Delete document',
    deleteConfirm: 'Delete “{{name}}”? This action cannot be undone.',
    deleteSuccess: 'Document deleted',
    deleteFailed: 'Failed to delete the document',
    downloadFailed: 'Failed to download the file',
    downloadNotFound: 'The file could not be found',
    downloadTimedOut: 'The download timed out. Check your connection and try again',
    downloadInProgress: 'This file is already downloading',
    deletePermissionHint: 'A document can be deleted by an administrator, its uploader, or a user with delete permission for that document.',

    // Document fields
    document: 'Document',
    category: 'Category',
    uploadedBy: 'Uploaded By',
    size: 'Size',
    modified: 'Modified',
    version: 'Version',

    // Filters
    filterBy: 'Filter by',
    categories: 'Categories',
    tags: 'Tags',
    fileTypes: 'File Types',
    dateRange: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    activeFilters: '{{count}} active filters',
    activeFilter: '{{count}} active filter',

    // Document Detail Page
    details: 'Details',
    versionHistory: 'Version History',
    permissions: 'Permissions',
    metadata: 'Metadata',
    department: 'Department',
    classification: 'Classification',
    retentionPeriod: 'Retention Period',
    lastModified: 'Last Modified',
    years: 'years',
    actions: 'Actions',
    preview: 'Preview',
    loadingPreview: 'Loading preview...',
    uploadNewVersion: 'Upload New Version',
    failedToLoad: 'Failed to load document',
    documentNotFound: 'Document not found',
    returnToDocuments: 'Return to Documents',
    analysisHistory: 'Analysis History',
    analysisHistoryView: {
      emptyTitle: 'This document does not have deep analysis history yet.',
      emptyDescription: 'Ask chat to run deep analysis for a selected document to record detailed technical analysis.',
      title: 'Analysis History ({{count}})',
      type: {
        deepTechnicalAnalysis: 'Deep technical analysis',
        summary: 'Summary',
        extraction: 'Data extraction',
      },
      createdBy: 'Created by: {{name}}',
      showContent: 'Show analysis content',
    },
    detailTabsAria: 'Document detail tabs',
    previewUnavailableForType: 'Preview is not available for {{type}}',
    spreadsheetPreviewFrameTitle: 'Read-only Excel document preview',
    previewLoadFailed: 'Failed to load preview',
    convertingSlidePreview: 'Converting the slides...',
    preparingSlidePreview: 'Preparing the slide preview...',
    slidePreviewFailed: 'The slide preview could not be prepared',
    slidePreviewFailedReason: {
      unconvertible: 'This presentation could not be converted for preview',
      timeout: 'This presentation took too long to convert for preview',
      unavailable: 'Preview conversion is unavailable',
      too_many_slides: 'This presentation has too many slides to preview',
    },
    slideNumber: 'Slide {{number}}',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    openFullImage: 'Open full-size image',
    previewLoadFailedWithStatus: 'Failed to load preview: {{status}}',
    previewLoadFailedWithStatusText: 'Failed to load preview: {{status}} {{statusText}}',
    fileTypeFallback: 'this file type',
    fileName: 'File Name',
    fileType: 'File Type',
    fileSize: 'File Size',
    status: 'Status',
    createdAt: 'Created At',
    reExtractMetadata: 'Re-extract Metadata',
    reExtractMetadataDescription: 'Use the LLM to regenerate metadata from the document. Select the fields you want to update.',
    regenerateTitle: 'Regenerate title',
    regenerateSummary: 'Regenerate summary',
    regenerateTags: 'Regenerate tags',
    tagTooLong: 'Tags must be {{max}} characters or fewer.',
    uploadMimeNotAllowed: '{{name}}: Unsupported file type ({{type}}).',
    uploadMimeUnknown: '{{name}}: The file type could not be determined. Try saving the file again.',
    reExtractingMetadata: 'Re-extracting metadata...',
    selectAtLeastOneMetadataField: 'Select at least one field.',
    metadataReExtracted: 'Metadata re-extracted ({{count}} field(s) updated).',
    metadataReExtractFailed: 'Failed to re-extract metadata.',
    reExtractConfirmAction: 'Re-extract',
    reExtractMetadataConfirmTitle: 'Re-extract metadata',
    reExtractMetadataConfirmMessage:
      'This will overwrite the title, summary and tags with AI-generated content. Any manual edits will be lost and this action cannot be undone. Are you sure you want to re-extract?',
    extractedImagesTitle: 'Extracted Images & Drawings',
    itemCount: '({{count}} items)',
    imageAnalysisComplete: 'Image analysis is complete.',
    imageAnalysisFailed: 'Image analysis failed.',
    imagesAnalyzed: 'Analyzed {{count}} images.',
    imagesReanalyzed: 'Reanalyzed {{count}} images.',
    imagesExtracted: 'Extracted {{count}} images.',
    blueprintImagesExtracted: 'Extracted {{count}} drawing images.',
    imageReExtractFailed: 'Failed to re-extract images.',
    blueprintReExtractFailed: 'Failed to re-extract drawing images.',
    aiAnalyzing: 'AI analysis in progress...',
    analyzeAllImages: 'Analyze all images with AI',
    forceReanalyze: 'Reanalyze existing analysis results',
    extracting: 'Extracting...',
    reExtractImages: 'Re-extract images',
    reExtractAsBlueprint: 'Re-extract as drawings',
    reExtractImagesConfirmTitle: 'Re-extract images',
    reExtractBlueprintConfirmTitle: 'Re-extract as blueprint',
    reExtractImagesConfirmMessage:
      'All extracted images and their AI analysis results will be deleted before images are extracted again. This action cannot be undone. Are you sure you want to re-extract?',
    analyzeAllImagesConfirmTitle: 'Re-analyze all images',
    analyzeAllImagesConfirmMessage:
      'Force re-analyze is enabled. The existing AI analysis for every image will be overwritten. This action cannot be undone. Are you sure you want to continue?',
    analyzeAllImagesConfirmAction: 'Re-analyze',
    imagesSelected: '{{count}} selected',
    selectTwoImages: 'Select two images.',
    selectAtLeastTwoImages: 'Select at least two images.',
    sequenceAnalysisMaxImages: 'Sequence analysis supports up to {{count}} images.',
    extractedImageAlt: 'Page {{page}}, Image {{index}}',
    imageLoadFailed: 'Unable to load image',
    imageFileNotFound: 'File not found',
    imagePageCaption: 'Page {{page}} - Image {{index}}',
    aiAnalysisResult: 'AI Analysis Result',
    analyzing: 'Analyzing...',
    reanalyze: 'Reanalyze',
    reanalyzeImageConfirmTitle: 'Re-run AI analysis',
    reanalyzeImageConfirmMessage:
      'The existing AI analysis will be overwritten and the previous result cannot be restored. Are you sure you want to re-run it?',
    reanalyzeImageConfirmAction: 'Re-analyze',
    aiAnalysis: 'AI Analysis',
    noExtractedImages: 'No images have been extracted from this document.',
    documentPermissions: 'Document Permissions',
    versionHistoryFetchFailed: 'Failed to fetch version history',
    versionHistoryLoadFailed: 'Failed to load version history',
    noDescription: 'No description',
    noVersionHistory: 'No version history available',
    versionWithNumber: 'Version {{version}}',
    versionWithCurrent: 'Version {{version}} (Current)',
    currentVersion: 'Current',
    deepAnalysisCompleted: 'Deep analysis completed',
    deepTechnicalAnalysis: 'Deep Technical Analysis',
    createdBy: 'Created by: {{name}}',
    compare: 'Compare',
    restore: 'Restore',
    compareWithCurrent: 'Compare with Current',
    restoreThisVersion: 'Restore This Version',
    compareVersions: 'Compare Versions',
    versus: 'vs',
    versionComparisonComingSoon: 'Version comparison view will be implemented here',
    pdfLoadFailed: 'Failed to load PDF document',
    pdfSearchTooltip: 'Search (press N/P to navigate results)',
    toggleResultsList: 'Toggle results list',
    searchInDocument: 'Search in document...',
    pageResultPreview: 'Page {{page}}: {{text}}...',
    previousResultShortcut: 'Previous (P)',
    nextResultShortcut: 'Next (N)',
    imageComparison: {
      title: 'Image Comparison & Linked Analysis',
      type: 'Comparison Type',
      compareTwo: 'Compare two',
      sequenceAnalysis: 'Sequence analysis ({{count}} items)',
      selectImagesHint: 'Select images to start comparison or linked analysis',
      compareResultTitle: 'Image Comparison Analysis Result',
      sequenceResultTitle: 'Image Sequence Analysis Result',
      aiAnalyzingPleaseWait: 'AI analysis in progress. Please wait.',
      typeWithValue: 'Comparison type: {{type}}',
      resultLoadFailed: 'Failed to retrieve analysis result',
      types: {
        changes: 'Changes',
        evolution: 'Design Evolution',
        differences: 'Differences',
      },
    },
  };

export default documents;
